import { configuratorConstants, ConfiguratorValueUpdateModel, Product } from "@/modules/ProductConfigurator/models";
import { productConfiguratorStore } from "@/modules/ProductConfigurator/store";

class Cookie {
    public applyCustomCookies(vm: any, selectedCustomConfiguratorProductCookie: string,  model: any ) {
        if (selectedCustomConfiguratorProductCookie !== "") {
            if (selectedCustomConfiguratorProductCookie.indexOf("%")) {
                selectedCustomConfiguratorProductCookie = decodeURI(selectedCustomConfiguratorProductCookie);
            }
            const cookieArray = JSON.parse(selectedCustomConfiguratorProductCookie);
            const vmTemp = vm;
            for (const cookie of cookieArray) {
                if (cookie.moduleId === vmTemp.id && cookie.value) {
                    model.wallSections =  cookie.value.wallSections;
                }
            }
        }
    }

    public cookieExists(cookieNames: string[]): boolean {
        let cookieExist = false;
        const cookies = document.cookie.split(";");
        for (const cookie of cookies) {
            for (const cookieName of cookieNames) {
                if (cookie.includes(cookieName)) {
                    cookieExist = true;
                    break;
                }
            }
            if (cookieExist) {
                break;
            }
        }
        return cookieExist;
    }

    public getCookie(cookie: string): string {
        const cookies = document.cookie.split(";");
        for (let i = 0; cookies.length > i; i++) {
            if (cookies[i].includes(cookie)) {
                return decodeURI(cookies[i].split("=")[1]);
            }
        }
        return "";
    }

    public getCookieFullNames(cookies: string[]): string[] {
        const cookieCollection = [];
        const allCookies = document.cookie.split(";");
        for (const allCookie of allCookies) {
            for (const cookie of cookies) {
                if (allCookie.includes(cookie)) {
                    cookieCollection.push(allCookie);
                }
            }
        }
        return cookieCollection;
    }

    public removeCookies(cookies: string[]) {
        const fullCookieNames = this.getCookieFullNames(cookies);
        const date = new Date();
        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        for (const cookieName of fullCookieNames) {
            document.cookie = cookieName + "=; expires=" + date.toUTCString() + ";";
        }
    }

    public getCookieStringList(cookieName: string): string[] {
        const cookie = this.getCookie(cookieName);
        if (cookie !== "") {
            const parses = JSON.parse(cookie);
            const propertyNameList = [];
            for (const parse of parses) {
                propertyNameList.push(parse.propertyName);
            }
            return propertyNameList;
        }
        return [];
    }

    public setCookie(cookieString: string, value: any, cookie: string): string {
        return this.createCookie(cookieString, value, cookie);
    }

    public createCookie(values: string, value: any, cookieName: string): string {
        if (values.indexOf("%") > -1) {
            values = decodeURI(values);
        }
        const now = new Date();
        now.setDate(now.getDate() + 1);
        const expires = "expires=" + now.toUTCString() + ";";
        let newValue = "";

        if (values && values !== "") {
            const valuesObjects = JSON.parse(values);
            const configValues = [];
            if (valuesObjects.length && valuesObjects.length > 0) {
                let addValueOnce = true;
                for (const valuesObject of valuesObjects) {
                    if (valuesObject.moduleId === value.moduleId && valuesObject.propertyName !== configuratorConstants.PlasterThicknessRange) {
                        if (valuesObject.isText || valuesObject.propertyName === configuratorConstants.RecommendedSectionProducts) {
                            if (valuesObject.propertyName !== value.propertyName && value.propertyName !== configuratorConstants.productList
                                && value.propertyName !== configuratorConstants.recommendedProductSelected) {
                                configValues.push(valuesObject);
                            } else if (value.propertyName !== configuratorConstants.productList && value.propertyName !== configuratorConstants.recommendedProductSelected) {
                                addValueOnce = false;
                                configValues.push(value);
                            }
                        } else if (addValueOnce) {
                               if (value.propertyName === configuratorConstants.productList) {
                                const articleNumbers = this.GetAddedProducts(value);
                                const newUpdateModelValue = value as ConfiguratorValueUpdateModel;
                                newUpdateModelValue.value = JSON.stringify(articleNumbers);
                                if (configValues.filter(x => x.propertyName === configuratorConstants.productList).length > 0) {
                                    configValues.filter(x => x.propertyName === configuratorConstants.productList)[0].value = JSON.stringify(articleNumbers);
                                } else {
                                    configValues.push(newUpdateModelValue);
                                }

                                const currentRecommenedValue = (valuesObjects as ConfiguratorValueUpdateModel[]).filter(x => x.propertyName === configuratorConstants.recommendedProductSelected);
                                if (currentRecommenedValue && currentRecommenedValue[0].value) {
                                    if (configValues.filter(x => x.propertyName === configuratorConstants.recommendedProductSelected).length > 0) {
                                        configValues.filter(x => x.propertyName === configuratorConstants.recommendedProductSelected)[0] = currentRecommenedValue[0];
                                    } else {
                                        configValues.push(currentRecommenedValue[0]);
                                    }
                                }
                                addValueOnce = false;
                            } else {
                                configValues.push(value);
                                addValueOnce = false;
                            }
                        }
                    } else {
                        if (value.propertyName === configuratorConstants.FloorType) {
                            if (configuratorConstants.ResetPropertiesOnFloorChange.indexOf(valuesObject.propertyName + ";") > -1) {
                                valuesObject.value = undefined;
                                configValues.push(valuesObject);
                            }
                        } else {
                            configValues.push(valuesObject);
                        }
                }
            }

                if (addValueOnce) {
                    // making sure value gets added
                    if (value.propertyName === configuratorConstants.productList) {
                        const articleNumbers = this.GetAddedProducts(value);
                        const newUpdateModelValue = value as ConfiguratorValueUpdateModel;
                        newUpdateModelValue.value = JSON.stringify(articleNumbers);
                        if (configValues.filter(x => x.propertyName === configuratorConstants.productList).length > 0) {
                            configValues.filter(x => x.propertyName === configuratorConstants.productList)[0].value = JSON.stringify(articleNumbers);
                        } else {
                            configValues.push(newUpdateModelValue);
                        }
                    } else if (value.propertyName === configuratorConstants.recommendedProductSelected) {
                        if (configValues.filter(x => x.propertyName === configuratorConstants.recommendedProductSelected).length > 0) {
                            configValues.filter(x => x.propertyName === configuratorConstants.recommendedProductSelected)[0].value = value.value;
                        } else {
                            configValues.push(value);
                        }
                    } else {
                        configValues.push(value);
                    }
                }
            } else {
                configValues.push(value);
            }

            if (configValues.length > 0) {
                this.filterConfigValues(configValues);
                newValue = encodeURI(JSON.stringify(configValues));
                document.cookie = cookieName + "=" + newValue;
                document.cookie = expires;
            }
        } else {
            newValue = encodeURI(JSON.stringify([value]));
            document.cookie = cookieName + "=" + newValue;
            document.cookie = expires;
        }
        return newValue;
    }

    public CreateCarbonSavingsCookie(cookieName: string, currentVariantId: string, ecoVariantId: string, packagingFactor: number) {
        const existingCookies = document.cookie.split(";");
        const now = new Date();
        now.setDate(now.getDate() + 1);
        const expires = "expires=" + now.toUTCString() + ";";

        if (existingCookies.some(x => x.indexOf(cookieName) > -1)) {
            let carbonSavingsCookie = existingCookies.find(x => x.indexOf(cookieName) > -1);
            if (carbonSavingsCookie && carbonSavingsCookie.indexOf(currentVariantId + "-" + ecoVariantId) < 0) {
                carbonSavingsCookie = carbonSavingsCookie + "$" + currentVariantId + "-" + ecoVariantId + "-" + packagingFactor;
                document.cookie = carbonSavingsCookie;
                document.cookie = expires;
            }
        } else {
            document.cookie = cookieName + "=" + currentVariantId + "-" + ecoVariantId + "-" + packagingFactor;
            document.cookie = expires;
        }
    }

    private GetAddedProducts(value: any) {
        const articleNumbers: string [] = [];
        productConfiguratorStore.products.map((x: Product) => {
        if (x.added) {
            articleNumbers.push(x.articleNumber);
            }
        });
        return articleNumbers;
    }

    private filterConfigValues(configValues: ConfiguratorValueUpdateModel[]): ConfiguratorValueUpdateModel[] {
        if (configValues.filter(x => x.propertyName === configuratorConstants.OuterCorners).length > 0) {
            const indexOfGroundShape = configValues.findIndex(x => x.propertyName === configuratorConstants.GroundShape);
            if (indexOfGroundShape > -1 && indexOfGroundShape !== configValues.length - 1) {
                configValues.splice(indexOfGroundShape, 1);
            }
        }

        if (configValues.filter(x => x.propertyName === configuratorConstants.GroundShape).length > 0) {
            const indexOfOuterCorners = configValues.findIndex(x => x.propertyName === configuratorConstants.OuterCorners);
            if (indexOfOuterCorners > -1 && indexOfOuterCorners !== configValues.length - 1) {
                configValues.splice(indexOfOuterCorners, 1);
            }
        }
        return configValues;
    }
}

export default new Cookie();
